import ErrorPage from 'next/error';
import PropTypes from 'prop-types';
import React, { createContext } from 'react';
import axios from 'axios';
import { useRouter } from 'next/router';

import { receiveEntities } from '../store';
import SEO from '../components/seo/SEO';
import StoryBody from '../components/StoryBody';
import sentry from '../utils/sentry';

const { captureException } = sentry();

export const StoryContext = createContext(null);
export const ShowLoginContext = createContext(null);

const getStatusCode = (code = null) => {
  if (code === 410) return 404;
  return code;
};

const Story = ({ storyId, statusCode }) => {
  const { asPath } = useRouter();
  const showLogin = !asPath.includes('no_wrapper');
  if (statusCode) return <ErrorPage statusCode={getStatusCode(statusCode)} />;
  return (
    <ShowLoginContext.Provider value={showLogin}>
      <StoryContext.Provider value={storyId}>
        <SEO storyId={storyId} />
        <StoryBody />
      </StoryContext.Provider>
    </ShowLoginContext.Provider>
  );
};

Story.propTypes = {
  storyId: PropTypes.string,
  statusCode: PropTypes.number,
};

Story.defaultProps = {
  statusCode: null,
  storyId: null,
};

Story.getInitialProps = async ctx => {
  const { reduxStore } = ctx;
  let storyId;
  let statusCode;
  await axios
    .get(`${process.env.apiBaseURL}/v3/public/stories/${ctx.query.id}`)
    .then(({ data }) => {
      storyId = data.data.id;
      return data;
    })
    .then(data => reduxStore.dispatch(receiveEntities(data)))
    .catch(error => {
      if (error.response) {
        statusCode = error.response.status;
      }
      captureException(error, ctx);
    });

  return { storyId, statusCode };
};

export default Story;
